import styled from 'styled-components'

import MenuItem from './MenuItem'
import Background from './Background'
import Link from './Link'

const FullscreenMenu = styled(Background).attrs({
  as: 'div',
})`
  z-index: 1030;
  position: fixed;
  top: 64px;
  left: 0;
  width: 100%;
  height: calc(100% - 64px);

  padding-top: 64px;

  ${Background} {
    position: relative;
    height: 100%;
  }

  ${MenuItem} {
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  ${Link} {
    font-size: 1.5em;
    font-weight: 400;
    padding: ${props => props.theme.gutter}px 0;
  }
`

export default FullscreenMenu
